import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { styled } from '@mui/material/styles';

import { getService, getFileService,postService,patchService } from '../../../../utils/services/httpService';

import Header from '../../../components/post-security/common/header';
import NewLesson from '../../../components/post-security/new-lesson/new_lesson';
import {Typography, Button} from '@mui/material';
import { Replay } from '@mui/icons-material';

const PREFIX = 'NewLesson';

const classes = {
    root_grid: `${PREFIX}-root_grid`,
    main: `${PREFIX}-main`,
    ll_view: `${PREFIX}-ll_view`,
    header: `${PREFIX}-header`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root_grid}`]: {
        display: 'grid',
        height: '100vh',
        'grid-template-rows': '48px auto',
        overflowY: 'visible',
    },

    [`& .${classes.main}`]: {
        'display': 'inline-flex',
        [theme.breakpoints.up('sm')]: {
            'padding-left': '70px',
            'padding-top': '20px',
            'padding-right': '70px',
            'padding-bottom': '20px',
        },
        'overflow': 'hidden',
    },

    [`& .${classes.ll_view}`]: {
        'maxWidth': 'calc(100vw - 70px - 60px - 30px)',
        // overflowX: 'auto',
    },

    [`& .${classes.header}`]: {
        zIndex: 999999,
    }
}));

class LLView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
            offline: false,
            lesson_id: null,
            lesson_data: {}
        };
        this.fetchNewLessonData = this.fetchNewLessonData.bind(this);
        this.formSubmitContainer = this.formSubmitContainer.bind(this); 
    }
    

    fetchNewLessonData = async (lesson_id) => {
        try {
            const responseFetchLessonView = await getService(this.props.auth, `lessons/${lesson_id}/?user_id=${localStorage.getItem('id')}`);
            
            if ((localStorage.getItem('ll_admin')==='true')||(localStorage.getItem('email')===responseFetchLessonView.data.author_email)) {
                this.setState({
                    ...this.state,
                    loading: false,
                    lesson_data: responseFetchLessonView.data
                })    
            } else {
                this.props.navigate('/ll/new-lesson', { replace: true });
            }
        }
        catch (error) {
            this.setState({ ...this.state, error: error, loading: false });
        }
    }
    
    formSubmitContainer = async (lessonFormData, request_type) => {
        try {
            if (request_type === 'post') {
                const saveLesson = await postService(this.props.auth, `lessons/`, lessonFormData, `multipart/form-data`);                
                this.props.navigate(`/ll/view/${saveLesson.data.id}`);            
            } else {
                // Attachments: Only can add more attachments rn. FormData only has info on new attachments.
                lessonFormData.append('author', this.props.auth.profile.email);
                const saveLesson = await patchService(this.props.auth, `lessons/${this.state.lesson_id}/?user_id=${localStorage.getItem('id')}`, lessonFormData, `multipart/form-data`);
                this.props.navigate(`/ll/new-lesson/${saveLesson.data.id}`);            
            }
        } catch (error) {
            this.setState({ ...this.state, error: error, loading: false });
        }
    }

    componentDidMount() {
        document.title = "Log a Lesson";

        let { lesson_id } = this.props.params;
        this.setState({lesson_id: lesson_id})
 
        if (lesson_id)  {
            this.fetchNewLessonData(lesson_id);
        } else {
            this.setState(
                {
                    loading: false, 
                    lesson_data: {
                        attachments: '',
                        author: this.props.auth.profile.email,
                        description: '',
                        division: 'general',
                        tags: [],
                        reviewed: false,
                        safety: false,
                        selectedActivities: '',
                        title: '',
                    }
                }
            )    
        }
    }

    render() {  
        const { } = this.props;        
        return (
            <Root>
                <div className={classes.root_grid}>
                    <div className={classes.header}>
                        {/* ***** Header Area ***** */}
                        <Header />
                    </div>
                    <div>
                        {this.state.offline ? (
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                You are offline!
                            </div>
                        ) : this.state.error ? (
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                <Typography variant="h5" style={{ fontFamily: 'inherit' }} gutterBottom>
                                    <strong>An error occured!</strong>
                                </Typography>
                                <center>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={() => window.location.reload()}
                                    >
                                        <Replay /> Try again
                                    </Button>
                                </center>
                            </div>
                        ) : this.state.loading ? (
                            <>Loading...</>                          
                        ) : (      
                            <>
                                <div className={classes.main}>
                                    <NewLesson 
                                        loading={this.state.loading}
                                        formSubmitContainer={this.formSubmitContainer}
                                        lesson_id={this.state.lesson_id}
                                        lesson_data={this.state.lesson_data}
                                        auth = {this.props.auth}                                        
                                        getFileService={getFileService}
                                    />
                                </div>
                            </>
                            )}
                        </div>
                    <div>
                    </div>                
                </div>
            </Root>
        );
    }
}

const NewLessonView = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    return <LLView {...props} params={params} navigate={navigate} />;
};

export default NewLessonView;